// .pageTop
import stickybits from "stickybits"
import SmoothScroll from "smooth-scroll"
const scroll = new SmoothScroll('.up a[href*="#"]')

export const stickyTopInit = () => {
  const topElement = document.querySelector(".pageTop")
  if (topElement) {
    stickybits(topElement)
    topElement.addEventListener("click", e => {
      e.preventDefault()
      scroll.animateScroll(document.querySelector(".pageContainer"), event.target, {
        offset: 250
      })
    })
  }
}
